export function test() {}

/**
 * Test if current field dependencies are filled
 * @param {*} current field value of tested node
 * @param {Array} deps dependencies of field
 * @author boris.nanista
 */
export function checkDependencies(current, deps = []) {
  if (current === undefined || current === null) {
    if (
      deps.some(value => {
        if (value === undefined) {
          return false;
        }

        if (value === null) {
          return false;
        }

        return true;
      })
    ) {
      return false;
    }

    return true;
  }

  return true;
}
